import { render, staticRenderFns } from "./ReportProblemDialog.vue?vue&type=template&id=3c9a076a&"
import script from "./ReportProblemDialog.vue?vue&type=script&lang=js&"
export * from "./ReportProblemDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports